import { FC, useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ISummary } from 'src/types';
import { AIARequestForm } from './aia/aiaRequestForm';
import { getFile } from 'src/services/schoolRequest';
import { useAuth } from 'src/contexts';
import { ErrorNotice, Loader } from 'src/generic/component';

const READ_ONLY_STATUSES = ['processing', 'appeal', 'international', 'testSecurity', 'opsApproved', 'completed'];
const isReadOnly = (summary: ISummary) => {
  const { processStatus, appealEligible } = summary;
  const cannotResubmit = (processStatus === 'rejected' && !appealEligible);
  return (READ_ONLY_STATUSES.includes(processStatus) || cannotResubmit);
};

// Retrieve the AIA form using the categoryId and userId with a custom hook here...
const useFile = (file: string) => {
  const [data, setData] = useState<any | undefined>(undefined);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [errorLoading, setError] = useState<string>('');

  const retrieve = async (file: string) => {
    setLoading(true);
    try {
      const request = await getFile(file);
      setData(request);
    } catch (error: any) {
      setError(error?.message || error);
    }
    setLoading(false);
  };

  useEffect(() => {
    retrieve(file);
  }, [file]);

  return { data, setData, isLoading, errorLoading };
};

export const FormPage: FC = () => {
  const { isAdmin } = useAuth();

  const location = useLocation();
  const state = location.state as any;
  const item = state?.summary as ISummary;
  const file = state?.file as string;

  const readOnly = isAdmin || isReadOnly(item);
  const filePath = file || ((readOnly) ? (item.submission || item.draft) : item.draft);

  const { data, isLoading, errorLoading } = useFile(filePath);

  if (isLoading) {
    return <Loader />;
  } else if (errorLoading) {
    return <ErrorNotice errorMessage={errorLoading} />;
  } else if (data) {
    if (item.appliedType === 'aia') {
      return <AIARequestForm readOnly={readOnly} request={data} item={item}></AIARequestForm>;
    } else {
      return <div>Unknown Summary Record!</div>;
    }
  } else {
    return <ErrorNotice errorMessage='No data returned from the server, something went wrong!' />;
  }
};